var map = {
	"./@astralito/animals/routes_animals.js": "8d90",
	"./@astralito/book/routes_book.js": "141c",
	"./@astralito/home/routes_home.js": "3c03",
	"./@astralito/others/routes_others.js": "c339",
	"./shop-payment-credit-card/routes_credit-card.js": "6c9d",
	"./shop/account/routes_account.js": "2eff",
	"./shop/catalog/routes_catalog.js": "d6cc",
	"./shop/checkout/routes_checkout.js": "b34e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8fdc";